import { HeatingGrades, HeatingGrade } from '../utils';

const reverseHeatingKeys = Array.from(HeatingGrades.keys()).reverse();

export const getReverseHGIndex = (hg: HeatingGrade) =>
  reverseHeatingKeys.indexOf(HeatingGrades.indexOf(hg));
